<script lang="ts">
    import { defineCustomElement as advPopup } from '@didi/adv-ui/adv-retention-dialog';
    import { createEventDispatcher, onMount } from 'svelte';
    import { get } from 'svelte/store';

    import { GroupType } from '../constants/common';
    import { JUMP_TYPE_ENUM, POPUP_ID } from '../enums/index';
    import { RETAIN_POPUP_CK } from '../enums/track';
    import {
        isJumpOneLInk,
        isParticipateActivity,
        omegaParams,
        groupType,
        awardCountdownSecondsLeft
    } from '../store/index';
    import { JumpLink } from '../utils/jumpTo';
    import { trackEvent } from '../utils/track';

    import { markPopBegin, markPopEnd } from '@/utils/fmpTrack';

    export let time = '60';
    export let width = '450';
    export let bid = 'creditcard';
    export let isOnePage = 'true';
    export let theme = '#3355ff';
    export let useCardEndTextStyle = false;

    type RetentionCopy = {
        title?: string;
        text?: string;
        confirmText?: string;
    };

    export let defaultRetentionCopy: RetentionCopy = {};
    export let participatedRetentionCopy: RetentionCopy = {};

    const participatedFallbackCopy = {
        title: '¡Aprovéchalo ya! ¡Tu cupón está listo！',
        text: 'Divide tus compras a 3 Meses Sin Intereses sin importar el monto o el comercio.',
        confirmText: 'Úsalo ahora'
    };
    const defaultFallbackCopy = {
        title: 'Ingresa tu número de celular y obtén 3 cupones de 3MSI.',
        text: 'Recibirás uno al mes. ¡Úsalos en cualquier comercio y sin importar el monto!',
        confirmText: 'Pídelo ahora'
    };

    $: participatedCopy = {
        ...participatedFallbackCopy,
        ...participatedRetentionCopy
    };
    $: defaultCopy = {
        ...defaultFallbackCopy,
        ...defaultRetentionCopy
    };

    const dispatch = createEventDispatcher();
    let popupElement: HTMLElement;

    const applyCardEndTextStyle = () => {
        if (!useCardEndTextStyle || !popupElement?.shadowRoot) {
            return;
        }

        const styleId = 'retention-card-end-text-style';

        if (popupElement.shadowRoot.getElementById(styleId)) {
            return;
        }

        const style = document.createElement('style');

        style.id = styleId;
        style.textContent = `
            .popup-credit-card--custom .credit-card--custom .main-title--custom {
                margin-top: 0.2rem;
                padding: 0 0.39rem;
            }

            .popup-credit-card--custom .credit-card--custom .main-title--custom .title {
                color: #0c0c0d;
                font-family: "DiDiSans-Pro-Regular", sans-serif;
                font-size: 0.32rem;
                font-weight: 400;
                font-style: normal;
                line-height: 0.4rem;
                letter-spacing: 0;
                text-align: left;
                white-space: nowrap;
            }
        `;

        popupElement.shadowRoot.appendChild(style);
    };

    onMount(async () => {
        advPopup();
        await customElements.whenDefined('adv-retention-dialog');
        applyCardEndTextStyle();
    });

    $: if (useCardEndTextStyle && popupElement) {
        setTimeout(applyCardEndTextStyle, 0);
    }

    const handleShowPopup = (e: CustomEvent) => {
        if (e.detail) {
            markPopBegin({ popup_id: POPUP_ID.RETENTION_POPUP });
        }

        dispatch('showPopupState', e.detail);
    };

    const isVisible = (e: CustomEvent) => {
        if (e.detail) {
            markPopEnd({ popup_id: POPUP_ID.RETENTION_POPUP });
        }
    };
    const handlePopupClose = async (e: CustomEvent) => {
        if (e?.detail?.closeType === 'close') {
            trackEvent(RETAIN_POPUP_CK, {
                button_name: 'close',
                is_jump_success: 0
            });
        } else if (e?.detail?.closeType === 'confirm' && $isParticipateActivity) {
            trackEvent(RETAIN_POPUP_CK, {
                button_name: 'cta',
                is_jump_success: 1
            });
            const jumpType = JUMP_TYPE_ENUM.TO_H5CREDITCARD;

            await JumpLink(jumpType, {
                awardCountdownNumber: get(awardCountdownSecondsLeft) ?? 0
            });
        } else if (e?.detail?.closeType === 'confirm' && !$isParticipateActivity) {
            trackEvent(RETAIN_POPUP_CK, {
                button_name: 'cta',
                is_jump_success: 0
            });
        }

    };

</script>

{#if $isParticipateActivity}
    <adv-retention-dialog
        bind:this={popupElement}
        {time}
        {width}
        {bid}
        role="dialog"
        aria-modal="true"
        credit-card-custom-layout={true}
        bg-color={$groupType === GroupType.B ? 'BLACK' : 'WHITE'}
        credit-card-title={participatedCopy.title}
        credit-card-text={participatedCopy.text}
        confirm-text={participatedCopy.confirmText}
        on:popupClose={handlePopupClose}
        on:isVisible={isVisible}
        is-one-page={isOnePage}
        params={$omegaParams}
        {theme}
        deep-link-state={$isJumpOneLInk}
        on:showPopupState={handleShowPopup}
    ></adv-retention-dialog>
{:else}
    <adv-retention-dialog
        bind:this={popupElement}
        bg-color={$groupType === GroupType.B ? 'BLACK' : 'WHITE'}
        {time}
        {width}
        {bid}
        role="dialog"
        aria-modal="true"
        credit-card-custom-layout={true}
        credit-card-title={defaultCopy.title}
        credit-card-text={defaultCopy.text}
        confirm-text={defaultCopy.confirmText}
        on:popupClose={handlePopupClose}
        on:isVisible={isVisible}
        is-one-page={isOnePage}
        params={$omegaParams}
        {theme}
        deep-link-state={$isJumpOneLInk}
        on:showPopupState={handleShowPopup}
    ></adv-retention-dialog>
{/if}
